import BreakBehindBreakoutModuleWide from './BreakBehindBreakoutModuleWide'

export default BreakBehindBreakoutModuleWide
